import { render, staticRenderFns } from "./BaseActionExpandDetails.vue?vue&type=template&id=01af28dc&scoped=true&"
import script from "./BaseActionExpandDetails.vue?vue&type=script&lang=js&"
export * from "./BaseActionExpandDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af28dc",
  null
  
)

export default component.exports